(function ($) {
  Drupal.behaviors.pcgProductMobileV1 = {
    attach: function (context, settings) {
      $('.pcg-product-mobile-v1').each(function () {
        var thisFormatter = $(this);
        // Check if the reviews img is tranparent.gif and add hidden class to .reviews parent class        
        var reviews = thisFormatter.find('.reviews'),
          reviewsImg = reviews.find('img');

        if (reviewsImg.attr('src') == '/media/export/images/global/transparent.gif') {
          reviews.addClass('hidden');
        }
      });
    }
  };

  $('.online-price').hover(function () {
    $(this).siblings('.online-price-hover-content').show();
  }, function () {
    var that = $(this).siblings('.online-price-hover-content');

    setTimeout(function () {
      if (!that.is(':hover')) {
        that.fadeOut(300);
      }
    }, 250);
  });
  $('.online-price-hover-content').mouseleave(function () {
    $(this).fadeOut(300);
  });
})(jQuery);
